// Libs
import _find from 'lodash/find'
import { createSelector } from 'reselect'

import { assets$ } from 'fc-assets'

export default function getAssetObject (assetId: number) {
  return createSelector(
    [
      assets$,
    ],
    (assets) => {
      return _find(assets, (asset) => asset.id === assetId)
    }
  )
}
